import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard, RoleBasedGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------
const OverviewAppPage = lazy(() => import('src/pages/dashboard/outsider-dashboard'));

// HOSTEL
const HostelOutsiderAllocationDetailPage = lazy(() => import('src/pages/dashboard/hostel-allocation-detail/allocation-detail'));
const FeeOutsiderCreatePage = lazy(() => import('src/pages/dashboard/hostel-allocation-detail/collect'));

// ----------------------------------------------------------------------

export const outsiderdashboardRoutes = [
  {
    path: 'outsiderdashboard',
    element: (
      <AuthGuard>
        <RoleBasedGuard roles={['admin','outsider']} hasContent>
          <DashboardLayout>
            <Suspense fallback={<LoadingScreen />}>
              <Outlet />
            </Suspense>
          </DashboardLayout>
        </RoleBasedGuard>
      </AuthGuard>
    ),
    children: [
      { element: <OverviewAppPage />, index: true },
      
   
         {
        path: 'fee',
        children: [
          { element: <HostelOutsiderAllocationDetailPage />, index: true },
          { path: 'list', element: <HostelOutsiderAllocationDetailPage /> },
          { path: 'collect', element: <FeeOutsiderCreatePage /> },

        ],
      },    

    ],
  },
];
